$(document).ready(function () {

    const defaultProductName = $('.product__title h1').text().trim();

    function updateTitle() {
        const selectedLabel = $('fieldset.js.product-form__input.product-form__input--pill.size input[type=radio]:checked + label span.firstname').text().trim();

        const newTitle = selectedLabel || defaultProductName;
        const currentTitle = $('.product__title h1').text().trim();


        if (currentTitle !== newTitle) {
            $('.product__title h1').text(newTitle);
        }
    }

    updateTitle();

    
    $(document).on('change', 'fieldset.js.product-form__input.product-form__input--pill.size input[type=radio]', function () {
        updateTitle();
    });


    const target = document.querySelector('fieldset.js.product-form__input.product-form__input--pill.size');
    if (target) {
        const observer = new MutationObserver(() => {
            updateTitle();
        });

        observer.observe(target, {
            childList: true,
            subtree: true
        });
    }
});
